import { render, staticRenderFns } from "./Reserva.vue?vue&type=template&id=f8a67734"
import script from "./Reserva.vue?vue&type=script&lang=js"
export * from "./Reserva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports